// @flow
export const GET_SETTINGS = {
	START: 'GET_SETTINGS.START',
	SUCCESS: 'GET_SETTINGS.SUCCESS',
	FAIL: 'GET_SETTINGS.FAIL',
};

export const TOGGLE_SOUND = 'TOGGLE_SOUND';
